// extracted by css-extract-rspack-plugin
export default {"citiesListWrapper":"citiesListWrapper-L7EXrt"};